var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-items',_vm._l((_vm.availableLocales),function(locale){return _c('v-btn',{key:locale,attrs:{"small":"","text":""},on:{"click":function($event){return _vm.setLocale(locale)}}},[_vm._v(_vm._s(locale))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }